const ListGenre = [
  "Comédies, films d'animation",
  'dessins animés',
  'Horreur',
  'Amour',
  'Policier, suspense',
  'Fantastique, Science-fiction, Action',
  'Guerre, histoire',
  'Western',
];

export default ListGenre;
